import { useMemo } from "react";

interface BuildTriggerLabelProps {
  source: string;
  pipelineTrigger?: {
    url: string;
    label: string;
  };
}

const BuildTriggerLabel = ({ source, pipelineTrigger }: BuildTriggerLabelProps) => {
  const label = useMemo(() => {
    switch (source) {
      case "webhook":
        return "Triggered from Webhook";
      case "ui":
        return "Triggered from Web";
      case "api":
        return "Triggered from API";
      case "trigger_job":
        return "Triggered from Pipeline";
      case "schedule":
        return "Triggered from Pipeline Schedule";
      default:
        return "Triggered from Unknown";
    }
  }, [source]);

  if (pipelineTrigger) {
    return (
      <span>
        Triggered from Webhook via{" "}
        <a href={pipelineTrigger.url} className="semi-bold color-inherit hover-color-inherit">
          {pipelineTrigger.label}
        </a>
      </span>
    );
  }

  return <span>{label}</span>;
};

export default BuildTriggerLabel;
